import { WorkspaceRole } from '../../../../../../api/workspaces/getWorkspaceMembers';

export const workspaceRoleToNameMap = new Map([
  [WorkspaceRole.Viewer, 'viewer'] as const,
  [WorkspaceRole.Editor, 'editor'] as const,
  [WorkspaceRole.Owner, 'owner'] as const,
]);
